module.exports = __webpack_public_path__ + "img/anis.8eaafc15.png";